<template>
  <v-dialog v-model="dialog" width="500px" persistent :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>THÊM ĐỐI TƯỢNG ÁP DỤNG</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" flat class="pa-3">
          <v-radio-group v-model="apply">
            <v-radio label="Một cấp cụ thể" value="academicLevel"></v-radio>
            <SelectAcademicLevel v-if="apply === 'academicLevel'" @change="academicLevelChange" />
            <v-radio label="Một khối cụ thể" value="grade"></v-radio>
            <AutocompleteGrade v-if="apply === 'grade'" v-model="selectedGrade" />
            <v-radio label="Một lớp cụ thể" value="class"></v-radio>
            <GradeClassSelect v-if="apply === 'class'" @changed="gradeClassChange" />
          </v-radio-group>
          <div></div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" outlined light depressed @click="cancel">Huỷ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" width="100px" class="elevation-0" @click="onSave">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import SelectAcademicLevel from '@/components/basic/input/SelectAcademicLevel.vue'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade.vue'
import GradeClassSelect from '@/components/basic/filter/GradeClassSelect.vue'
export default {
  components: { GradeClassSelect, SelectAcademicLevel, AutocompleteGrade },
  data() {
    return {
      dialog: false,
      apply: null,
      selectedGrade: null,
      selectedClass: null,
      selectedAcademicLevel: null
    }
  },

  methods: {
    ...mapActions({
      create: 'survey/create'
    }),
    openDialog() {
      this.dialog = true
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      this.apply = null
      this.selectedGrade = null
      this.selectedClass = null
      this.selectedAcademicLevel = null
    },
    gradeClassChange(data) {
      this.selectedClass = data.class
    },
    academicLevelChange(data) {
      this.selectedAcademicLevel = data
    },
    onSave() {
      if (this.$refs.form.validate()) {
        let data = {}
        if (this.apply === 'academicLevel') data = this.selectedAcademicLevel
        if (this.apply === 'grade') data = this.selectedGrade
        if (this.apply === 'class') data = this.selectedClass
        data.type = this.apply
        this.$emit('onSave', data)
        this.cancel()
      }
    }
  }
}
</script>
